import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=d561b4e6&scoped=true&"
import script from "./PayDialog.vue?vue&type=script&lang=ts&"
export * from "./PayDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PayDialog.vue?vue&type=style&index=0&id=d561b4e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d561b4e6",
  null
  
)

export default component.exports